import { createFileRoute } from "@tanstack/react-router"

import { marketingPages } from "@/lib/marketing-pages"
import { seoMeta } from "@/lib/seo"

import { PluginsPage } from "./-components/PluginsPage"

export const Route = createFileRoute("/features/plugins/")({
  head: () =>
    seoMeta({
      title: "Plugins · Entire",
      description: marketingPages["/features/plugins"].description,
      url: "https://entire.com/features/plugins",
      image: "/images/og/plugins.png",
      imageAlt: "Integrate with Entire — accepting launch partners",
    }),
  component: PluginsPage,
})
